<ion-card class="menu-history">
    <div class="card-content">
        <ion-card-header>
            <ion-title>{{ 'VersionHistory' | translate }}</ion-title>
        </ion-card-header>

        <ion-card-content class="ion-card-content">

            <div class="timeline-wrapper-list">

                <div class="timeline-row-box current-version-item" [class.is-active]="menuHistory.activeIndex === 0" (click)="selectMenuVersion(0)">
                    <div class="timeline-node">
                        <div class="node-circle"></div>
                    </div>
                    <div class="timeline-text-content">
                        <span class="version-title">
                            {{ 'CurrentVersion' | translate }}
                        </span>
                    </div>
                </div>
 
                <cdk-accordion class="history-accordion">
                    <cdk-accordion-item #accordionItem="cdkAccordionItem" class="history-accordion-item">
                        <button
                            class="timeline-row-box accordion-header-btn"
                            (click)="accordionItem.toggle()"
                            tabindex="0"
                            [attr.aria-expanded]="accordionItem.expanded">
                            <div class="timeline-node">
                                <div class="node-circle"></div>
                            </div>
                            <div class="timeline-text-content flex-header">
                                <span class="version-title">
                                    {{ menuHistory.versions.length || 0 }} {{ 'AutosaveVersions' | translate }}
                                </span>
                                <ion-icon
                                    name="caret-down-outline"
                                    class="icon-caret"
                                    [class.is-open]="accordionItem.expanded"></ion-icon>
                            </div>
                        </button>

                        @if(accordionItem.expanded) {
                            <div class="example-accordion-item-body" role="region">
                                <div class="inner-list">
                                    @for(item of menuHistory.versions; track $index) {
                                        <div
                                            class="sub-history-item"
                                            [class.is-active]="menuHistory.activeIndex === $index"
                                            (click)="$event.stopPropagation(); selectMenuVersion($index)">
                                            <span class="history-time">
                                                {{ getDate(item.timestamp) }}
                                            </span>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </cdk-accordion-item>
                </cdk-accordion>

            </div>

        </ion-card-content>
    </div>
</ion-card>